module.exports = __webpack_public_path__ + "static/74cff99d9435ea39a8f163b18ef1cf16.svg";